import { COMPANY_SHORT, ABOUT_IMAGE_URL, PUBLIC_INFO } from '../constants';

function AboutSection() {
  return (
    <section id="about" className="bg-cream">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-20 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
        <div className="relative">
          <div
            aria-hidden
            className="absolute -left-3 -top-3 h-full w-full rounded-[2.25rem] bg-rose/50"
          />
          <div className="relative overflow-hidden rounded-[2.25rem] border border-line bg-surface shadow-soft">
            <img
              src={ABOUT_IMAGE_URL}
              alt={`Editorial image representing ${COMPANY_SHORT}`}
              className="h-[460px] w-full object-cover opacity-50 saturate-0"
            />
            <div
              aria-hidden
              className="absolute inset-0 bg-gradient-to-t from-plum via-plum/30 to-rose/20"
            />
            <div className="absolute inset-x-0 bottom-0 p-7 text-petal">
              <p className="text-[11px] font-black uppercase tracking-[0.24em] text-petal/70">
                Editorial Image
              </p>
              <p className="font-display mt-1 text-2xl">A signal for what comes next.</p>
            </div>
          </div>
        </div>

        <div>
          <p className="text-xs font-black uppercase tracking-[0.22em] text-sage">
            About Inflection
          </p>
          <h2 className="font-display mt-3 text-4xl tracking-tight text-ink sm:text-5xl">
            Personal intelligence, with people in the frame.
          </h2>
          <p className="mt-5 leading-8 text-muted">
            Inflection’s public mission centers on AI that improves human well-being and productivity. Its work explores AI models that combine emotional intelligence with technical intelligence — making interactions more contextual and relational.
          </p>
          <div className="mt-8 grid gap-3 sm:grid-cols-2">
            {PUBLIC_INFO.map((item) => (
              <div
                key={item.label}
                className="rounded-2xl border border-line bg-surface/70 px-5 py-4"
              >
                <p className="text-[11px] font-black uppercase tracking-[0.2em] text-sage">
                  {item.label}
                </p>
                <p className="mt-1.5 font-semibold text-ink">{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
